import React from 'react';

const OrdersEmptyGraphicSvg = (props) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#FFF"
                fillRule="nonzero"
                d="M97.882 31.026l-7.947 4.355L79.557 30.2l-9.98 5.18-10.703-5.88-10.934 5.245-7.128-3.718.57 74.388c.033 4.406 3.632 7.96 8.059 7.96h52.334c6.03 0 10.917-4.865 10.917-10.865s-4.888-10.864-10.917-10.864H98.89l-1.008-60.62z"
            />
            <path
                fill="#F6682F"
                fillRule="nonzero"
                d="M60.796 110.259l46.833.049-1.515 2.618-49.368.383z"
            />
            <path
                fill="#F6682F"
                fillRule="nonzero"
                d="M52.356 90.779l-11.691 11.726c.46 6.107 5.558 10.813 11.693 10.813h.445c5.417 0 9.973-4.044 10.588-9.4l-.269-3.266c-.458-5.578-5.141-9.873-10.766-9.873z"
            />
            <path
                fill="#282C35"
                fillRule="nonzero"
                d="M54.487 49.673h30.438v3.147H54.487v-3.147zm0 11.407h30.438v3.147H54.487V61.08zm0 11.408h30.438v3.147H54.487v-3.147zM51.412 114.601h49.655v-2.188H51.412z"
            />
            <path
                fill="#282C35"
                fillRule="nonzero"
                d="M51.954 114.06h48.567v-1.106H51.954v1.106zm-1.085 1.082h50.742v-3.27H50.869v3.27z"
            />
            <g transform="translate(52.312 90.779)">
                <mask id="orders-empty-graphic_svg__a" fill="#fff">
                    <path d="M48.735 2.166c5.505 0 9.966 4.42 9.966 9.867 0 5.383-4.394 9.604-9.966 9.604V23.8c6.703 0 12.138-5.12 12.138-11.767C60.873 5.387 55.438 0 48.735 0v2.166zM0 2.21c5.505 0 9.966 4.424 9.966 9.872 0 5.367-4.379 9.554-9.966 9.554V23.8c6.705 0 12.14-5.073 12.14-11.717C12.14 5.437 6.705.048 0 .048V2.21z" />
                </mask>
                <path
                    fill="#282C35"
                    fillRule="nonzero"
                    mask="url(#orders-empty-graphic_svg__a)"
                    d="M-10.873 34.615h82.617v-45.432h-82.617z"
                />
            </g>
            <path
                fill="#282C35"
                fillRule="nonzero"
                d="M52.854 112.942v1.084c6.242-.266 11.056-5.073 11.056-11.164 0-6.157-4.911-11.198-11.056-11.481v1.084c5.544.279 9.969 4.837 9.969 10.397 0 5.485-4.335 9.818-9.969 10.08m-.543 2.176h-.544v-3.245h.544c5.285 0 9.425-3.957 9.425-9.01 0-5.145-4.229-9.332-9.425-9.332h-.544v-3.245h.544c6.994 0 12.686 5.643 12.686 12.576 0 6.874-5.572 12.256-12.686 12.256m49.28-2.176v1.084c6.243-.266 11.052-5.095 11.052-11.215 0-6.156-4.91-11.194-11.051-11.478v1.084c5.541.28 9.964 4.836 9.964 10.394 0 5.512-4.336 9.867-9.964 10.131m-.544 2.176h-.543v-3.245h.543c5.283 0 9.42-3.98 9.42-9.062 0-5.143-4.226-9.327-9.42-9.327h-.543v-3.245h.543c6.992 0 12.682 5.64 12.682 12.572 0 6.9-5.57 12.307-12.682 12.307"
            />
            <g transform="translate(52.312 90.615)">
                <mask id="orders-empty-graphic_svg__b" fill="#fff">
                    <path d="M.002.161h48.731v2.188H.002z" />
                </mask>
                <path
                    fill="#282C35"
                    fillRule="nonzero"
                    mask="url(#orders-empty-graphic_svg__b)"
                    d="M-10.871 13.168h70.472v-23.822h-70.472z"
                />
            </g>
            <path
                fill="#282C35"
                fillRule="nonzero"
                d="M52.856 92.425H100.5V91.32H52.856v1.105zm-1.087 1.082h49.817v-3.269H51.769v3.269z"
            />
            <g transform="translate(39.226 27)">
                <mask id="orders-empty-graphic_svg__c" fill="#fff">
                    <path d="M30.042 6.622L19.554.835 9.144 6.62.04 1.443v73.363c0 .136 0 .136.004.268.15 7.051 6.011 12.65 13.099 12.505l-.046-2.163c-5.885.119-10.755-4.53-10.879-10.387-.002-.074-.002-23.359-.002-69.856l6.916 3.933 10.427-5.798 10.496 5.796 10.214-5.79 10.286 5.773 8.186-4.035v58.824h2.176V1.564L50.62 6.64 40.265.829 30.042 6.622z" />
                </mask>
                <path
                    fill="#282C35"
                    fillRule="nonzero"
                    mask="url(#orders-empty-graphic_svg__c)"
                    d="M-10.829 98.396h82.617V-9.991h-82.617z"
                />
            </g>
            <path
                fill="#282C35"
                fillRule="nonzero"
                d="M39.811 29.375l.002 72.686c.137 6.562 5.472 11.826 12.001 11.975l-.022-1.084c-5.93-.158-10.766-4.946-10.892-10.913-.002-.093-.002-28.17-.002-69.869v-.93l7.464 4.245 10.422-5.795 10.495 5.794 10.216-5.794 10.303 5.783 8.714-4.294v59.155h1.087v-60.9l-9.768 4.817-10.336-5.803-10.225 5.794-10.488-5.79-10.414 5.79-8.557-4.868v.001zm12.288 85.745c-7.249 0-13.22-5.79-13.373-13.035l-.002-.277V27.513l9.649 5.486 10.407-5.785 10.484 5.787 10.227-5.796 10.372 5.822 10.823-5.335v63.725h-3.26V32.923L89.765 36.7 79.5 30.937l-10.214 5.788-10.499-5.796-10.432 5.798-6.369-3.624c0 47.068 0 68.727.002 68.923.115 5.472 4.631 9.849 10.11 9.849.072 0 .143 0 .215-.003l.544-.01.07 3.245-.544.01c-.096.003-.19.003-.283.003h-.001z"
            />
        </g>
    </svg>
);

OrdersEmptyGraphicSvg.displayName = 'OrdersEmptyGraphicSvg';
export default OrdersEmptyGraphicSvg;
